import React from "react";
import { SvgIcon } from "@mui/material";

/* from https://materialdesignicons.com/
 */

export function WidthIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z" />
    </SvgIcon>
  );
}

export function HeightIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z" />
    </SvgIcon>
  );
}

export function DimsIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M13,11H18L16.5,9.5L17.92,8.08L21.84,12L17.92,15.92L16.5,14.5L18,13H13V18L14.5,16.5L15.92,17.92L12,21.84L8.08,17.92L9.5,16.5L11,18V13H6L7.5,14.5L6.08,15.92L2.16,12L6.08,8.08L7.5,9.5L6,11H11V6L9.5,7.5L8.08,6.08L12,2.16L15.92,6.08L14.5,7.5L13,6V11Z" />
    </SvgIcon>
  );
}

export function BlankIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="" />
    </SvgIcon>
  );
}

export function AmplitudeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M 0,12 C 0,12 5,32 12,12 18.75,-8.75 24,12 24,12" />
    </SvgIcon>
  );
}

export function ContrastIcon() {
  return (
    
    <svg width="24px" height="24px" viewBox="0 0 24 24">
      <path
        fill="#000000"
        d="M12 2A10 10 0 0 0 2 12A10 10 0 0 0 12 22A10 10 0 0 0 22 12A10 10 0 0 0 12 2M12 4A8 8 0 0 1 20 12A8 8 0 0 1 12 20V4Z"
      />
    </svg>
  );
}

export function FrontIcon() {
  return (
    <SvgIcon >
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="#434343" className="bi bi-grid-3x2">
      <g id="SVGRepo_bgCarrier" strokeWidth="5"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v8a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5v-8zM1.5 3a.5.5 0 0 0-.5.5V7h4V3H1.5zM5 8H1v3.5a.5.5 0 0 0 .5.5H5V8zm1 0v4h4V8H6zm4-1V3H6v4h4zm1 1v4h3.5a.5.5 0 0 0 .5-.5V8h-4zm0-1h4V3.5a.5.5 0 0 0-.5-.5H11v4z"></path>
      </g>
    </svg>
    </SvgIcon>
  );
}
export function PerspectiveIcon() {
  return (
    <SvgIcon >
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve" fill="#434343" stroke="#000000">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC" strokeWidth="10.24"></g>
        <g id="SVGRepo_iconCarrier">
          <g>
            <path style={{fill:"#434343"}} d="M512,502.605H0V9.395l350.005,60.619v210.838L52.362,478.224H512V502.605z M24.381,38.359v429.154 l301.243-199.737V90.51L24.381,38.359z"></path>
            <polygon style={{fill:"#434343"}} points="416.963,344.942 237.47,344.942 237.47,54.109 261.851,54.109 261.851,320.561 416.963,320.561 "></polygon>
            <rect x="9.346" y="199.51" transform="matrix(0.9826 -0.1856 0.1856 0.9826 -36.2508 36.1626)" style={{fill:"#434343"}} width="331.345" height="24.372"></rect>
            <polygon style={{fill:"#434343"}} points="468.545,419.507 125.058,419.507 125.058,45.527 149.439,45.527 149.439,395.126 468.545,395.126 "></polygon>
            <rect x="337.814" y="262.095" style={{fill:"#434343"}} width="45.462" height="24.381"></rect>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
